import { FC } from "react";

import { DeleteModal } from "shared/components";
import { IAPIState, StateErrorType } from "shared/types";
import {
  DeleteInfoBlockItemBaseProps,
  getInfoBlockItemName,
} from "shared/utils";

interface DeleteInfoBlockItemModalProps extends DeleteInfoBlockItemBaseProps {
  itemReadbleName: string;
  extraDeleteMessage?: string | null;
  deleteItemApiStatus?: IAPIState;
  deleteItemApiError?: StateErrorType;
  handleDelete: () => void;
}

export const DeleteInfoBlockItemModal: FC<DeleteInfoBlockItemModalProps> = ({
  type,
  deleteItem,
  itemReadbleName,
  handleClose,
  handleDelete,
  deleteItemApiStatus,
  deleteItemApiError,
  extraDeleteMessage,
}) => {
  return (
    <DeleteModal
      type={itemReadbleName}
      name={getInfoBlockItemName(deleteItem, type)}
      message={extraDeleteMessage}
      apiMeta={
        deleteItemApiStatus
          ? {
              status: deleteItemApiStatus,
              error: deleteItemApiError,
            }
          : undefined
      }
      handleClose={handleClose}
      handleDelete={handleDelete}
    />
  );
};
